import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseBadge, Button, Card, RuleAudienceIcon } from '@/lib';
import { SuggestedAudience } from '../types';

interface SuggestedAudienceCardProps {
  audience: SuggestedAudience;
  onCreateAudience?: (audience: SuggestedAudience) => void;
  isCreateDisabled?: boolean;
}

export const SuggestedAudienceCard: FC<SuggestedAudienceCardProps> = ({ audience, onCreateAudience, isCreateDisabled = false }) => {
  const { t } = useTranslation('marketIntelligence');

  return (
    <Card className='flex h-full flex-col gap-3.5 border-primary-border bg-white p-6 drop-shadow-none'>
      <p className='text-[11px] font-semibold uppercase tracking-[0.08em] text-brand-700'>{t('report.suggestedAudiences.cardEyebrow')}</p>
      <h4 className='text-lg font-semibold text-primary-900'>{audience.title}</h4>
      <p className='text-sm leading-6 text-primary-600'>{audience.description}</p>
      {audience.evidence.length > 0 ? (
        <div className='flex flex-wrap gap-2'>
          {audience.evidence.map((chip) => (
            <BaseBadge
              key={chip}
              className='rounded-full border border-primary-border bg-[rgb(244,247,251)] px-3 py-1.5 text-xs font-semibold text-primary-700'
            >
              {chip}
            </BaseBadge>
          ))}
        </div>
      ) : null}
      <div className='mt-auto pt-1.5'>
        <Button intent='primary' size='md' disabled={isCreateDisabled} onClick={() => onCreateAudience?.(audience)}>
          <RuleAudienceIcon className='size-4' />
          <span>{t('report.suggestedAudiences.createCta')}</span>
        </Button>
      </div>
    </Card>
  );
};
